import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"upload\">\n  <path fill=\"currentColor\" d=\"M11.116 5.027a2.67 2.67 0 1 0 .278 5.33h67.52a2.665 2.665 0 1 0 0-5.33h-67.52a2.666 2.666 0 0 0-.278 0Zm33.927 14.215a2.665 2.665 0 0 0-1.721.722L23.776 38.62a2.665 2.665 0 1 0 3.665 3.859L42.49 28.126V82.32a2.665 2.665 0 1 0 5.33 0V28.126L62.867 42.48a2.663 2.663 0 0 0 3.879.013 2.666 2.666 0 0 0-.214-3.872L46.987 19.964a2.667 2.667 0 0 0-1.944-.722Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol